import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-notificacoes-detalhes',
  standalone: false,
  templateUrl: './notificacoes-detalhes.component.html',
  styleUrl: './notificacoes-detalhes.component.css'
})
export class NotificacoesDetalhesComponent {
  notificacao: any;
  icone = 'info';

  constructor(
    private dialogRef: MatDialogRef<NotificacoesDetalhesComponent>,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.notificacao = data.notificacao;

    if (this.notificacao.type === 'success') this.icone = 'circle-check-big';
    if (this.notificacao.type === 'warning') this.icone = 'circle-alert';
    if (this.notificacao.type === 'danger') this.icone = 'circle-alert';
    if (this.notificacao.type === 'info') this.icone = 'circle-alert';
  }

  fechar() {
    this.dialogRef.close();
  }

  acessarModulo() {
    if (this.notificacao.moduleUrl) {
      window.open(this.notificacao.moduleUrl, '_blank');
    }
  }

  copiarLink() {
    const link = this.notificacao.shareUrl || this.notificacao.moduleUrl;
    if (!link) return;

    navigator.clipboard.writeText(link);
  }
}
